import { api } from '@cwd/lib/main';
import { UserAccountRole } from '../../Views/Account/AccountUsers.access';

export { UserAccountRole };

export interface UserReference {
    UserId: string;
    FirstName: string | null;
    LastName: string | null;
    Name: string | null;
    UserName: string | null;
    Email: string | null;
}

export interface RoleSummary {
    RoleId: string;
    Name: string;
    InternalDescription: string | null;
    Created: string;
    CreatedBy: string | null;
    Modified: string | null;
    ModifiedBy: UserReference | null;
}

export interface RolePermission {
    Feature: number;
    Permission: number;
}

export interface Role {
    RoleId: string;
    Name: string;
    InternalDescription: string | null;
    AccountId: string;
    Created: string;
    CreatedBy: string | null;
    Modified: string | null;
    ModifiedBy: UserReference | null;
    Permissions: RolePermission[];
}

export interface FeatureSummary {
    Name: string;
    Value: number;
    Executable: boolean;
    HideRead: boolean;
}

export interface FeatureRequirement {
    Feature: number;
    Permission: number;
    RequiredFeature: number;
    RequiredPermission: number;
}

export const getRoles = (): Promise<RoleSummary[]> => api.get('/Roles');
export const getRole = (roleId: string): Promise<Role> => api.get(`/Roles/${roleId}`);
export const createRole = (role: Partial<Role>): Promise<Role> => api.post('/Roles', role);
export const updateRole = (roleId: string, role: Partial<Role>): Promise<void> => api.post(`/Roles/${roleId}`, role);
export const deleteRole = (roleId: string, replacementRoleId: string | null, replacementRoleType: UserAccountRole): Promise<void> =>
    api.delete(`/Roles/${roleId}`, { ReplacementRoleId: replacementRoleId, ReplacementRoleType: replacementRoleType });
export const getFeatures = (): Promise<FeatureSummary[]> => api.get('/Roles/Features');
export const getFeatureRequirements = (): Promise<FeatureRequirement[]> => api.get('/Roles/FeatureRequirements');
